import React, { useEffect, useState } from 'react'
import { Image } from 'react-bootstrap'
import imgEmployee from '../../../images/EmployeeBtn.svg'
import { getRightMenuProfileAPI } from '../../../services/right-menu'
import { useDispatch } from 'react-redux'

function ProfileRight({ openSystemChange, openSystem1, setOpenSystem1 }) {
  const [profile, setProfile] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    const getRightMenuProfile = async () => {
      const res = await getRightMenuProfileAPI()
      if (!res) return
      if (res.status) {
        setProfile(res.result)
      }
    }
    setClickedIndex1(null)
    getRightMenuProfile()
  }, [])

  const [clickedIndex1, setClickedIndex1] = useState(null)

  const handleClickProfile = (p, i) => {
    setClickedIndex1(i)
    setOpenSystem1(
      i === clickedIndex1 ? !openSystem1 && openSystemChange : true
    )
    dispatch({ type: 'SET_STATUS_ID', payload: p.status_id ?? '' })
  }

  return (
    <span className="col-2">
      {profile.map((p, i) => (
        <span className="" key={i}>
          <div
            className={`pt-2 pb-2 button-box pointer-event ${
              clickedIndex1 === i ? 'clicked' : ''
            }`}
            key={i}
            onClick={() => handleClickProfile(p, i)}
          >
            <span className="d-flex gap-2">
              <span className="m-4 mt-0 mb-0 me-0">
                <Image src={imgEmployee} alt="Employee Image" />
              </span>
              <span className="mt-1">{p.status_name}</span>
            </span>
          </div>
        </span>
      ))}
    </span>
  )
}

export default ProfileRight
